import { ProductColor, Product } from 'idt-ecommerce-api/catalog/products/products.models';

import { MediasHelpers } from './medias/medias.helpers';
import { MediaClazzType, MediaLocation, MediaResolved, MediaContentTypeType, MediaLocationTypeValues } from './medias/medias.models';


export class ProductsHelpers {

  public static firstImageForFirstColor(
    colors: ProductColor[],
    location: MediaLocation,
    width?: number,
    clazzType?: MediaClazzType | string, // eslint-disable-line @typescript-eslint/no-redundant-type-constituents
    set?: number,
    mediaOriginalNames?: string[],
    customLocation?: number
  ): MediaResolved | undefined {
    let firstImage: MediaResolved | undefined;

    if (customLocation !== undefined && customLocation >= 0) {
      location = MediaLocationTypeValues[customLocation] || 'category_page';
    }

    if (colors.length > 0) {
      firstImage = MediasHelpers.firstMediaResolved(colors[0].medias, location, width, clazzType as MediaClazzType, 'image', set, mediaOriginalNames);
    }

    return firstImage;
  }

  public static firstImageForColor(
    color: ProductColor,
    location: MediaLocation,
    width?: number,
    clazzType?: MediaClazzType | string, // eslint-disable-line @typescript-eslint/no-redundant-type-constituents
    set?: number,
    mediaOriginalNames?: string[]
  ): MediaResolved | undefined {
    return MediasHelpers.firstMediaResolved(color.medias, location, width, clazzType as MediaClazzType, 'image', set, mediaOriginalNames);
  }

  public static imagesForColor(
    color: ProductColor,
    location: MediaLocation,
    width?: number,
    mediaContentType?: MediaContentTypeType,
    clazzType?: MediaClazzType
  ): MediaResolved[] {
    const images = MediasHelpers.mediasResolved(color.medias, location, width, clazzType, mediaContentType);
    return images;
  }

  public static allImagesForProduct(
    product: Product,
    location: MediaLocation,
    width?: number,
    clazzType?: MediaClazzType
  ): MediaResolved[] {
    let imagesForProduct: MediaResolved[] = [];
    for (const color of product.colors || []) {
      const mediasForColor = MediasHelpers.mediasResolved(color.medias, location, width, clazzType, 'image');
      imagesForProduct = imagesForProduct.concat(mediasForColor);
    }
    return imagesForProduct;
  }

}
